import React from 'react';
import './AdminFormControl.css';
import './EventFormFields.css';

interface EventFormFieldsProps {
  name: string;
  month: string;
  months: readonly string[];
  disabled: boolean;
  inputIdPrefix: string;
  onNameChange: (name: string) => void;
  onMonthChange: (month: string) => void;
  nameInputRef?: React.Ref<HTMLInputElement>;
  nameTestId?: string;
  monthTestId?: string;
  helpText?: React.ReactNode;
}

export function EventFormFields({
  name,
  month,
  months,
  disabled,
  inputIdPrefix,
  onNameChange,
  onMonthChange,
  nameInputRef,
  nameTestId,
  monthTestId,
  helpText
}: EventFormFieldsProps) {
  return (
    <div className="event-form-fields">
      <div className="event-form-fields__group">
        <label className="event-form-fields__label" htmlFor={`${inputIdPrefix}-name`}>Event Name:</label>
        <input
          ref={nameInputRef}
          id={`${inputIdPrefix}-name`}
          type="text"
          value={name}
          onChange={(event) => onNameChange(event.target.value)}
          placeholder="Enter event name..."
          className="admin-form-control admin-form-control--focus-ring event-form-fields__input"
          maxLength={100}
          required
          disabled={disabled}
          data-testid={nameTestId}
        />
      </div>
      <div className="event-form-fields__group">
        <label className="event-form-fields__label" htmlFor={`${inputIdPrefix}-month`}>Month:</label>
        <select
          id={`${inputIdPrefix}-month`}
          value={month}
          onChange={(event) => onMonthChange(event.target.value)}
          className="admin-form-control admin-form-control--focus-ring event-form-fields__select"
          required
          disabled={disabled}
          data-testid={monthTestId}
        >
          {months.map((validMonth) => <option key={validMonth} value={validMonth}>{validMonth}</option>)}
        </select>
        {helpText && <small className="help-text">{helpText}</small>}
      </div>
    </div>
  );
}
